// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { Modal } from 'components/atoms/Modal';
import dayjs from 'dayjs';
import TableFilterCalendar from '../TableFilterCalendar';
import { DATE_FORMAT } from 'util/ConstantValues';
import IconCalendarTablet from 'components/atoms/icons/IconCalendarTablet';
import styles from './CollectDateSelectModal.module.scss';
import { IconClose } from 'components/atoms/icons/IconClose';
import { useTranslation } from 'react-i18next';

type CollectDateSelectModalProps = {
  state: [dayjs.Dayjs | undefined, (date: dayjs.Dayjs | undefined) => void];
  onSubmitAndFinish: () => void;
  onSubmitAndContinue?: () => void;
};

const CollectDateSelectModal: React.FC<CollectDateSelectModalProps> = ({
  state,
  onSubmitAndFinish,
  onSubmitAndContinue,
}) => {
  const [selectedDate, setSelectedDate] = state;
  const { t } = useTranslation();

  const handleChangeDate = (val: string | undefined) => {
    let day = val ? dayjs(val) : undefined;

    if (!day) {
      setSelectedDate(undefined);
      return;
    }

    if (day.isBefore(dayjs(), 'day')) {
      day = day.endOf('day');
    } else if (day.isAfter(dayjs(), 'day')) {
      day = day.startOf('day');
    } else {
      day = dayjs();
    }

    setSelectedDate(day);
  };

  return (
    <Modal centered isSmall contentClassName={styles.Wrapper}>
      <div className={styles.Head}>
        <div className={styles.Title}>
          {t('collect_registration.select_received_date')}
        </div>
        <div onClick={() => setSelectedDate(undefined)}>
          <IconClose />
        </div>
      </div>

      <div className={styles.Body}>
        <TableFilterCalendar
          isSingle
          value={selectedDate?.format(DATE_FORMAT.slaYMDHm)}
          onChange={handleChangeDate}
          expanded={{
            icon: <IconCalendarTablet />,
          }}
          allowClear={false}
          calendarWrapperStyle={{
            zIndex: 30001,
          }}
          align="center"
          portalPositionPoint={(ref) => ref}
        />

        <div className={styles.ButtonGroup}>
          {onSubmitAndContinue && (
            <button
              className={styles.FinishButton}
              onClick={onSubmitAndContinue}
            >
              {t('collect_registration.button_submit_and_continue')}
            </button>
          )}

          <button className={styles.SubmitButton} onClick={onSubmitAndFinish}>
            {!onSubmitAndContinue
              ? t('collect_registration.button_to_recover')
              : t('collect_registration.button_submit_and_finish')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CollectDateSelectModal;
